import { render } from "./MyReview.vue?vue&type=template&id=00f9719e"
import script from "./MyReview.vue?vue&type=script&lang=js"
export * from "./MyReview.vue?vue&type=script&lang=js"

import "./MyReview.vue?vue&type=style&index=0&id=00f9719e&lang=css"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__